import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/16/solid'
import styles from './BackButton.module.scss'
//onBack에는 단일 페이지 컴포넌트에서 (page)--를 하는 함수를 넣으면 된다 <BackButton onBack={() => setPage(page - 1)} />처럼

export default function BackButton({ fallback = '/', onBack }) {
	const navigate = useNavigate()

	const handleBack = () => {
		if (onBack) {
			onBack()
			return
		} else if (window.history.length > 1) {
			navigate(-1) // 브라우저 히스토리 한 칸 뒤로
		} else {
			navigate(fallback, { replace: true }) // 히스토리가 없으면 지정한 경로로
		}
	}

	return (
		<button type="button" onClick={handleBack} className={styles.backBtn}>
			<ArrowLeftIcon style={{ width: '12px', height: '12px', color: '#A0A0A0' }} />
			<span className={styles.backBtnText}>뒤로</span>
		</button>
	)
}
